module.exports = __webpack_public_path__ + "img/avatar.d15ea7f8.png";